'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'PDF eSignature SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Sign PDFs for Free Using HelloSign',
            subtitle: 'Looking for a free tool to eSign a PDF? HelloSign provides legally binding and secure eSignatures for all your documents.',
            buttonText: 'IT\'S ALWAYS FREE TO TRY!'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How do you sign a PDF without printing?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'If you want to skip printing, signing, and scanning a document, you can do it all using the ',
                _react2['default'].createElement(
                    'a',
                    { href: '/', target: '_blank', rel: 'noopener noreferrer' },
                    'HelloSign'
                ),
                ' eSignature app.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Upload your document, sign it, and send it to the intended recipient. You also have the option to send your PDF out with a signature request if you need someone else (or several people!) to sign the document.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How should you send your eSigned PDF?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'There are several ways to send an eSigned PDF. You have the following options when you use HelloSign:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Send it directly from the eSignature app'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Download the document and attach it to an email'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Fax it using our other service, ',
                    _react2['default'].createElement(
                        'a',
                        { href: 'https://www.hellofax.com',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'HelloFax'
                    )
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How much does it cost to use HelloSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign is an eSignature app where you can sign up to 3 documents per month for free. If you need more documents to be signed or are looking for more features (like templates), a Pro account or higher may be more suitable for you. Check out our ',
                _react2['default'].createElement(
                    'a',
                    { href: '/info/pricing',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'pricing page'
                ),
                ' for the features per plan.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Is this legal?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'The short answer is, \u201CYes, it is.\u201D eSignatures are backed by the ESIGN Act of 2000, which gives ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'eSignatures the same legality as written'
                ),
                'signatures.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'There are certain types of documentation that are not included in the ESIGN Act and must still be signed on paper:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Adoption and divorce paperwork'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Court orders and notices'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Wills, codicils, and trusts'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Cancellations of utility services (includes power, water, and heat)'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Notices of repossession, foreclosure, eviction, or the right to cure'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Product recalls or material failure'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Documentation that accompanies hazardous materials, pesticides, or other toxic or dangerous materials'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Can you use Preview or Word instead of an eSignature service to eSign a PDF?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Using software such as Preview or Word to sign your document is ',
                _react2['default'].createElement(
                    'strong',
                    null,
                    'not considered a secure method of eSigning'
                ),
                '. Even though you can paste an image of your signature from a scanned image to get a similar-looking result to an eSignature, these programs don\u2019t provide the security protections that eSignature services do.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'At HelloSign, we have ',
                _react2['default'].createElement(
                    'a',
                    { href: '/info/security',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'securities built in'
                ),
                '. Your documents are encrypted using SSL (Secure Sockets Layer), which is the same level of encryption used by leading banks and government agencies. We also have an audit trail that\u2019s appended to all signature requests so you have record of your business processes.'
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get started: eSign a document for free',
            subtitle: 'Have a document to sign? Use HelloSign as your PDF eSignature app for free (we even have mobile apps for iOS and Android). If you’re looking for more features for your business (for example, team features, in-person signing, or signer access codes), request a demo with one of our eSignature experts.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/pdf-esignature.jsx
 ** module id = 1230
 ** module chunks = 0
 **/